import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeGa';
const args = {};

export class ModeGa extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
